import { createSlice, PayloadAction, Dispatch } from "@reduxjs/toolkit";

interface ViewModeState {
  activeView: any;
}

const initialState: ViewModeState = {
  activeView: { label: "Chart", value: "chart" },
};

const viewModeSlice = createSlice({
  name: "viewMode",
  initialState,
  reducers: {
    _setViewMode: (state: ViewModeState, action: PayloadAction<any>) => {
      state.activeView = action.payload;
    },
  },
});

export const { _setViewMode } = viewModeSlice.actions;

// Intercept tab changes to trigger global entrance/exit animations
export const setViewMode = (payload: any): any => (dispatch: Dispatch) => {
  // Start exit animation
  document.body.classList.add("view-mode-exiting");

  setTimeout(() => {
    // Perform the state change
    dispatch(_setViewMode(payload));

    // Swap to entrance animation
    document.body.classList.remove("view-mode-exiting");
    document.body.classList.add("view-mode-entering");

    // Clean up entering class
    setTimeout(() => {
      document.body.classList.remove("view-mode-entering");
    }, 300);
  }, 250); // duration of exit animation
};

export default viewModeSlice.reducer;
